import { defineMessages } from "react-intl";

export default defineMessages({
  reviews: {
    id: "rating.reviews",
    defaultMessage: "({count} avis)",
  },
});
